import React, { useState, useEffect } from "react";
import CustomButton from "../../../pages/CustomButton";
import { fetchStates, fetchEmployees, loadScheme, fetchDivisions, fetchEmployeeChemistSchemeReport } from "../../../services/stockistService";
const Scheme = () => {
  const currentDate = new Date();

  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const [schemeTypes, setSchemeTypes] = useState([]);
  const [selectedScheme, setSelectedScheme] = useState("");

  const [divisions, setDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState("");

  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth() + 1);

  const [report, setReport] = useState([]);

  const years = [2024, 2025, 2026];
  const months = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];
const monthLabel = months.find(m => m.id === Number(selectedMonth))?.name || "Month";

  // Load States
  useEffect(() => {
    const loadStates = async () => {
      try {
        const list = await fetchStates();
        setStates(list);
      } catch {
        console.log("Failed to load states");
      }
    };
    loadStates();
  }, []);

  // Load Employees when State changes
  useEffect(() => {
    const loadEmployees = async (stateId) => {
      if (!stateId) return;
      try {
        const list = await fetchEmployees(stateId);
        setEmployees(list);
      } catch {
        console.log("Failed to load employees");
      }
    };
    loadEmployees(selectedState);
  }, [selectedState]);

  // Load Schemes when State changes
  useEffect(() => {
    const loadSchemeList = async (stateId) => {
      if (!stateId) return;
      try {
        const list = await loadScheme(stateId);
        setSchemeTypes(list);
      } catch {
        console.log("Failed to load schemes");
      }
    };
    loadSchemeList(selectedState);
  }, [selectedState]);

  // Load Divisions (no state dependency)
  useEffect(() => {
    const loadDivisions = async () => {
      try {
        const list = await fetchDivisions();
        setDivisions(list);
      } catch {
        console.log("Failed to load divisions");
      }
    };
    loadDivisions();
  }, []);

  // GO BUTTON CLICK
  const handleGoClick = async () => {
    if (!selectedState || !selectedEmployee) {
      alert("Please select state and employee");
      return;
    }

    const payload = {
      state_id: parseInt(selectedState),
      year: parseInt(selectedYear) >= 2000 ? parseInt(selectedYear) : undefined,
      month: parseInt(selectedMonth) >= 1 && parseInt(selectedMonth) <= 12 ? parseInt(selectedMonth) : undefined,
      division: divisions.find((d) => d.id === parseInt(selectedDivision))?.name || undefined,
      employee_id: parseInt(selectedEmployee),
      scheme_id: selectedScheme ? parseInt(selectedScheme) : undefined,
    };

    console.log("PAYLOAD SENDING → ", payload);

    const data = await fetchEmployeeChemistSchemeReport(payload);
    setReport(data);
  };

  return (
    <div className="">
      <div className=" items-center rounded-xl bg-white p-6 shadow-lg border border-gray-600">
        <div>
          <h2 className="text-2xl font-bold flex justify-center  gap-2">
            <span className="text-blue-700">Productwise </span>
            <span className="text-blue-500">Scheme</span>
          </h2>
        </div>

        {/* ROW 1 */}
        <div className="grid grid-cols-2 gap-30 items-center justify-items-center">
          {/* State */}
          <div className="flex items-center gap-4">
            <label className="font-medium whitespace-nowrap">State</label>
            <select
              className="border border-gray-300 rounded-md w-56 px-3 py-1"
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </select>
          </div>

          {/* Employee */}
          <div className="flex items-center gap-4">
            <label className="font-medium whitespace-nowrap">Employee</label>
            <select
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
              className="border border-gray-300 rounded-md w-56 px-3 py-1"
            >
              <option value="">Select Employee</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.first_name} {emp.last_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* ROW 2 */}
        <div className="grid grid-cols-2 gap-30 items-center justify-items-center">
          {/* Scheme Type */}
          <div className="flex items-center gap-2 mr-12">
            <label className="font-medium whitespace-nowrap">Scheme Type</label>
            <select
              value={selectedScheme}
              onChange={(e) => setSelectedScheme(e.target.value)}
              className="border border-gray-300 rounded-md w-56 px-3 py-1"
            >
              <option value="">Select Scheme</option>
              {schemeTypes.map((scheme) => (
                <option key={scheme.id} value={scheme.id}>
                  {scheme.scheme_name}
                </option>
              ))}
            </select>
          </div>

          {/* Division */}
          <div className="flex items-center gap-4 mt-5 ml-5">
            <label className="font-medium whitespace-nowrap">Division</label>
            <select
              value={selectedDivision}
              onChange={(e) => setSelectedDivision(e.target.value)}
              className="border border-gray-300 rounded-md w-56 px-3 py-1"
            >
              <option value="">Select Division</option>
              {divisions.map((div) => (
                <option key={div.id} value={div.id}>
                  {div.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* ROW 3 */}
        <div className="grid grid-cols-2 gap-30 items-center justify-items-center">
          {/* Year */}
          <div className="flex items-center gap-4">
            <label className="font-medium whitespace-nowrap">Year</label>

            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="border border-gray-300 rounded-md w-56 px-3 py-1"
            >
              <option value="">Years</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          {/* Month */}
          <div className="flex items-center gap-4 mt-5 ml-6">
            <label className="font-medium whitespace-nowrap">Month</label>
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="border border-gray-300 rounded-md w-56 px-3 py-1"
            >
              <option value="">Month</option>
              {months.map((month) => (
                <option key={month.id} value={month.id}>
                  {month.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* SUBMIT BUTTON */}
        <div className="flex justify-center">
          <CustomButton variant="go" onClick={handleGoClick}>
            GO
          </CustomButton>
        </div>
      </div>

  {report.length > 0 && (
  <>
    {/* TABLE */}
    <div className=" items-center rounded-xl bg-white p-6 shadow-lg border border-gray-600 mt-7 max-h-96 overflow-y-auto hide-scrollbar">
      <table className="w-full border-collapse">
       <thead className="sticky top-0 bg-white z-10 shadow text-white">
  <tr className="bg-gray-100 text-white">
   <th className="px-3 py-2 border">S.No</th>
<th className="px-3 py-2 border">Emp ID</th>
<th className="px-3 py-2 border">Employee</th>
<th className="px-3 py-2 border">Retailer</th>
<th className="px-3 py-2 border">City</th>
<th className="px-3 py-2 border">Area</th>
<th className="px-3 py-2 border">Route</th>
<th className="px-3 py-2 border">Total POB</th>
<th className="px-3 py-2 border">Total Gift</th>
<th className="px-3 py-2 border">{monthLabel} Count</th>

  </tr>
</thead>


  <tbody>
 {report.map((item, index) => (
  <tr key={index}>
    <td className="border px-3 py-2">{index + 1}</td>
    <td className="border px-3 py-2">{item.employee_id}</td>
    <td className="border px-3 py-2">{item.employee_name}</td>
    <td className="border px-3 py-2">{item.chemist_name}</td>
    <td className="border px-3 py-2">{item.city}</td>
    <td className="border px-3 py-2">{item.area}</td>
    <td className="border px-3 py-2">{item.route}</td>
    <td className="border px-3 py-2">{item.total_pob}</td>
    <td className="border px-3 py-2">{item.total_gift}</td>
    <td className="border px-3 py-2">{item.total_pob}</td>
  </tr>
))}

</tbody>

      </table>
    </div>
  </>
)}

    </div>
  );
};

export default Scheme;
